import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface PlaceLabel {
  id: string;
  name: string;
  municipality: string | null;
  landskap: string | null;
  status: string;
}

export function usePlaceLinkingLabel(placeId: string | null | undefined) {
  return useQuery<PlaceLabel | null>({
    queryKey: ['place-linking-label', placeId],
    queryFn: async () => {
      if (!placeId) return null;
      const { data, error } = await supabase.rpc('get_place_linking_label', {
        p_place_id: placeId,
      });
      if (error) throw error;
      const rows = data as PlaceLabel[] | null;
      return rows?.[0] ?? null;
    },
    enabled: !!placeId,
    staleTime: 60_000,
  });
}
